import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import { CandidateType } from "constants/global";
import typography from "constants/typography.constants";
import { useController } from "react-hook-form";

interface ISelectCandidateTypeProps {
  resetCandidateFields?: () => void;
  isEditing: boolean;
}

const SelectCandidateType = ({ resetCandidateFields, isEditing }: ISelectCandidateTypeProps) => {
  const {
    field: { value, onChange },
  } = useController({
    name: "candidateType",
  });
  return (
    <FormControl disabled={!isEditing}>
      <FormLabel id='demo-radio-buttons-group-label'>Вид авторизации</FormLabel>
      <RadioGroup
        name='candidate-type'
        value={value}
        onChange={(_, radioValue) => {
          onChange(radioValue as CandidateType);
          resetCandidateFields?.();
        }}>
        <FormControlLabel
          value={CandidateType.Telegram}
          control={<Radio />}
          label={typography.candidate.form.withTelegram}
        />
        <FormControlLabel
          value={CandidateType.Login}
          control={<Radio />}
          label={typography.candidate.form.withLogin}
        />
      </RadioGroup>
    </FormControl>
  );
};

export default SelectCandidateType;
